import { getAccessToken } from "../auth/tokenStore";
import { getApiBaseUrl } from "./apiBaseUrl";

/**
 * Shared accessor for GET /company/info.
 *
 * App.js (travel feature flag) and CurrencyContext (company currency) both need
 * this payload on load and were each requesting it, doubling a round trip on
 * every page load. Concurrent callers share one in-flight request.
 */
let inFlight = null;
let cached = null;

export const fetchCompanyInfo = async ({ force = false } = {}) => {
  if (!force && cached) return cached;
  if (!force && inFlight) return inFlight;

  const token = getAccessToken();
  if (!token) return null;

  inFlight = (async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}/company/info`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (!response.ok) return null;
      cached = await response.json();
      return cached;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
};

/** Drop the cached payload — call after anything that mutates company info. */
export const invalidateCompanyInfo = () => {
  cached = null;
  inFlight = null;
};
